import { Trans } from 'react-i18next';

import {
    Body1,
    getIconByName,
    IconTile,
    List,
    ListItem,
} from '@myphx-engineering/phx-design-system';

import type { PathwayCardContent } from '../../../../configuration/shared';

interface CardBulletsProps {
    content: PathwayCardContent;
    testIdPrefix: string;
}

export const CardBullets = ({ content, testIdPrefix }: CardBulletsProps) => {
    if (!content.bullets?.length) return null;

    return (
        <List data-testid={`${testIdPrefix}-bullets`}>
            {content.bullets.map((bullet) => {
                const Icon = getIconByName(bullet.icon);
                return (
                    <ListItem
                        key={bullet.key}
                        icon={
                            <IconTile
                                color={bullet.color}
                                shape="circle"
                                size="xs"
                                Icon={Icon}
                            />
                        }
                    >
                        <Body1>
                            <Trans
                                ns="dynamic"
                                components={{ b: <strong />, br: <br /> }}
                            >
                                {bullet.text}
                            </Trans>
                        </Body1>
                    </ListItem>
                );
            })}
        </List>
    );
};
